module.exports = __webpack_public_path__ + "static/img/shadow-left-to-right.72c5bc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shadow-left-to-right.svg
// module id = 1N1L
// module chunks = 1